import 'components/desktop/BaseIngredient/Search/Components/SearchResultList/SearchResultList.scss';
import ArchiveResultListRow from 'components/desktop/BaseIngredient/Search/Components/SearchResultListRow/ArchiveResultListRow';
import SearchResultListRow from 'components/desktop/BaseIngredient/Search/Components/SearchResultListRow/SearchResultListRow';
import * as BaseIngredient from 'types/BaseIngredient/Search/BaseIngredient';
import * as BaseIngredientList from 'types/BaseIngredient/Search/BaseIngredientList';

interface IProps {
	archive: boolean;
	handleArchiveBaseIngredient: (input: string) => Promise<void>;
	handleRestoreBaseIngredient: (input: string) => Promise<void>;
	baseIngredientList: BaseIngredientList.Type;
}

const SearchResultList = (props: IProps) => {
	return (
		<div className="row-gy-4">
			<div className="col-lg-12">
				{props.archive ? (
					<>
						{props.baseIngredientList.map((obj: BaseIngredient.Type, i: number) => {
							return (
								<div key={i}>
									<ArchiveResultListRow
										handleRestoreBaseIngredient={
											props.handleRestoreBaseIngredient
										}
										baseIngredient={obj}
									/>
								</div>
							);
						})}
					</>
				) : (
					<>
						{props.baseIngredientList.map((obj: BaseIngredient.Type, i: number) => {
							return (
								<div key={i}>
									<SearchResultListRow
										handleArchiveBaseIngredient={
											props.handleArchiveBaseIngredient
										}
										baseIngredient={obj}
									/>
								</div>
							);
						})}
					</>
				)}
			</div>
		</div>
	);
};

export default SearchResultList;
